import { Link } from 'react-router-dom';
import { analytics } from '../lib/analytics';
import '../styles/landing.css';

const PLANS = [
  {
    name: 'Free',
    desc: 'For individuals getting started',
    price: '$0',
    period: 'forever',
    features: ['5 diagrams', '10 AI generations/month', '1 workspace', 'Community support'],
    featured: false,
  },
  {
    name: 'Pro',
    desc: 'For power users and freelancers',
    price: '$12',
    period: '/month',
    features: [
      'Unlimited diagrams',
      '200 AI generations/month',
      '5 workspaces',
      'Priority support',
      'Export to SVG/PNG',
    ],
    featured: true,
  },
  {
    name: 'Team',
    desc: 'For teams that ship fast',
    price: '$29',
    period: '/month per seat',
    features: [
      'Everything in Pro',
      'Unlimited workspaces',
      'Team member management',
      'Role-based access',
      'Shared revision history',
    ],
    featured: false,
  },
];

export function PricingPage() {
  return (
    <div className="landing">
      <nav className="landing-nav">
        <Link to="/" className="landing-nav__brand">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="landing-nav__logo">
            <path d="M3 4l9 16 9-16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <path d="M7 4h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
          </svg>
          <span className="landing-nav__name">Sketchflow</span>
        </Link>
        <div className="landing-nav__actions">
          <Link to="/login" className="landing-btn landing-btn--ghost landing-btn--sm">Sign in</Link>
          <Link to="/register" className="landing-btn landing-btn--primary landing-btn--sm">Get started</Link>
        </div>
      </nav>

      <section className="landing-section landing-section--center" style={{ paddingTop: 140 }}>
        <div className="landing-section__label">Pricing</div>
        <h1 className="landing-section__title">Simple, transparent pricing</h1>
        <p className="landing-section__desc">
          Start free. Upgrade when you need more power. Cancel anytime via PayPal.
        </p>

        <div className="landing-pricing">
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={`landing-price-card ${plan.featured ? 'landing-price-card--featured' : ''}`}
            >
              {plan.featured && <div className="landing-price-card__badge">Most popular</div>}
              <div className="landing-price-card__name">{plan.name}</div>
              <div className="landing-price-card__desc">{plan.desc}</div>
              <div className="landing-price-card__amount">{plan.price}</div>
              <div className="landing-price-card__period">{plan.period}</div>
              <ul className="landing-price-card__features">
                {plan.features.map((f) => (
                  <li key={f} className="landing-price-card__feature">{f}</li>
                ))}
              </ul>
              <Link
                to="/register"
                className={`landing-btn ${plan.featured ? 'landing-btn--primary' : 'landing-btn--ghost'}`}
                style={{ width: '100%', justifyContent: 'center' }}
                onClick={() => {
                  analytics.pricingViewed();
                  analytics.planSelected(plan.name.toLowerCase());
                }}
              >
                {plan.price === '$0' ? 'Get started free' : 'Start free trial'}
              </Link>
            </div>
          ))}
        </div>
      </section>

      <footer className="landing-footer">
        <div className="landing-footer__bottom">
          &copy; {new Date().getFullYear()} Sketchflow. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
